module.exports = __webpack_public_path__ + "img/技术支持.20d41b04.jpg";